"use client";
import useTranslate from "@app/_hooks/useTranslate";
import { LoginButton } from "@components/header/components/Actions";
import { Heading } from "@components/ui/Heading/Heading";
import { useAuth } from "@context/authContext";

import { useCheckoutContext } from "./Checkout.hooks";

export default function CheckoutHeading() {
  const t = useTranslate();
  useCheckoutContext();
  const { auth } = useAuth();

  return (
    <section>
      <div className="flex items-center justify-between p-4 lg:py-8">
        <Heading as="h1" size={5}>
          {t("yourCart")}
        </Heading>
        {!auth?.user && (
          <p className="hidden text-sm uppercase md:block">
            {t("alreadyHaveAnAccount")}{" "}
            <LoginButton
              className="inline-block uppercase underline"
              redirectOnSuccess={false}
            >
              {t("login")}
            </LoginButton>
          </p>
        )}
      </div>
      <div className="hidden w-full pb-2 pl-[140px] pr-3 uppercase child:text-sm child:text-color-base lg:grid lg:grid-cols-[3fr_1fr_1fr_1fr]">
        <p className="col-start-2 text-end">{t("quantity")}</p>
        <p className="col-start-3 text-end">{t("pricePerItem")}</p>
        <p className="col-start-4 text-end">{`${t("total")} (${t("vatIncluded")})`}</p>
      </div>
    </section>
  );
}
